import React, {useState, useEffect } from 'react';
import Question from './Question';

const Questions = ({questions, handleSelection}) => {

  return(
    <>
    {questions.map( question => (
      <Question 
        key={question.value}
        value={question.value}
        options={question.options}
        title={question.title}
        handleSelection={handleSelection}
      />
    ))}
    </>
  )
}

export default Questions;